/* import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable'; */
import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import posthog from 'posthog-js';
import '@fullcalendar/react/dist/vdom';
import App from './App';
import Main from './Main';
import './helpers/initFA';
import reportWebVitals from './reportWebVitals';

if (import.meta.env.VITE_PUBLIC_POSTHOG_KEY) {
  posthog.init(import.meta.env.VITE_PUBLIC_POSTHOG_KEY, {
    api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST || 'https://us.i.posthog.com',
    person_profiles: 'identified_only',
    capture_pageview: false,
    autocapture: true,
  });
}

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || 'development',
  integrations: [new BrowserTracing()],
  tracesSampleRate: 0.1,
  ignoreErrors: [
    'ResizeObserver loop limit exceeded',
    'Network request failed',
    /^ChunkLoadError/,
  ],
});

ReactDOM.render(<Main><App/></Main>,document.getElementById('main'));
reportWebVitals();